import {API} from 'aws-amplify';

export const read = async () => API.get('eventmanagerAdminApi', '/guests', {});

export const readOne = async (id) => API.get('eventmanagerAdminApi', `/guests/${id}`, {});

export const create = async (guest) => API.put('eventmanagerAdminApi', `/guests`, {body: guest});

export const update = async (guest) => API.post('eventmanagerAdminApi', `/guests`, {body: guest});

export const del = async (id) => API.del('eventmanagerAdminApi', `/guests/${id}`, {});
